import { Routes } from '@angular/router';
import { CONFIGURACOES_ROUTES } from '@/features/configuracoes/configuracoes.constants';

const DA = CONFIGURACOES_ROUTES.DIVIDA_ATIVA;

/** Rotas do grupo "Dívida Ativa" das Configurações (migração das configs do módulo DA do SIA). */
const configuracoesDividaAtivaRoutes: Routes = [
    {
        path: DA.ROOT,
        data: { breadcrumb: 'Dívida Ativa' },
        children: [
            { path: '', redirectTo: DA.DADOS_GERAIS, pathMatch: 'full' },
            { path: DA.DADOS_GERAIS, loadComponent: () => import('./dados-gerais/dados-gerais').then((m) => m.DividaAtivaDadosGerais), data: { breadcrumb: 'Dados Gerais' } },
            { path: DA.ENTIDADES, loadComponent: () => import('./entidades/entidades').then((m) => m.DividaAtivaEntidades), data: { breadcrumb: 'Entidades' } },
            { path: DA.DOCUMENTOS, loadComponent: () => import('./documentos/documentos').then((m) => m.DividaAtivaDocumentos), data: { breadcrumb: 'Documentos' } },
            { path: DA.ASSINANTES, loadComponent: () => import('./assinantes/assinantes').then((m) => m.DividaAtivaAssinantes), data: { breadcrumb: 'Assinantes' } }
        ]
    }
];

export default configuracoesDividaAtivaRoutes;
